import React from 'react';

const Cross = ({ width = 19, height = 19, colour = '' }) => {
    return (
        <svg
            className={'stroke-current ' + colour}
            viewBox="0 0 11.384 11.384"
            height={height}
            width={width}
        >
            <g transform="translate(1.061 1.061)">
                <g transform="translate(0 0)">
                    <path
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5px"
                        d="M1.25,10.511l9.263-9.263"
                        transform="translate(-1.25 -1.248)"
                    />
                    <path
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5px"
                        d="M10.513,10.511,1.25,1.248"
                        transform="translate(-1.25 -1.248)"
                    />
                </g>
            </g>
        </svg>
    );
};

export default Cross;
